import {
    ADD_GARAGE,
    UPDATE_GARAGE,
    DELETE_GARAGE,
    GET_GARAGES,
    GET_GARAGE,
    GARAGE_ERROR,
} from "../../actions/types";

const initialState = {
    garages: [],
    garage: null,
    loading: true,
    error: {},
};

export default function foo(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        // ADD/UPDATE carry a single garage, not the whole collection — assigning
        // the payload straight to `garages` turned the list into a non-array and
        // broke the list screen's `.map()`.
        case ADD_GARAGE:
            return {
                ...state,
                garages: [...state.garages, payload],
                garage: payload,
                loading: false,
            };
        case UPDATE_GARAGE:
            return {
                ...state,
                garages: state.garages.map((g) =>
                    g._id === payload?._id ? payload : g
                ),
                garage: payload,
                loading: false,
            };
        case DELETE_GARAGE:
            return {
                ...state,
                garages: Array.isArray(payload) ? payload : state.garages,
                loading: false,
            };
        case GET_GARAGE:
            return {
                ...state,
                garage: payload,
                error: {},
                loading: false,
            };
        case GET_GARAGES:
            return {
                ...state,
                garages: Array.isArray(payload) ? payload : [],
                error: {},
                loading: false,
            };
        case GARAGE_ERROR:
            return {
                ...state,
                garage: null,
                error: payload,
                loading: false,
            };
        default:
            return state;
    }
}
